import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { MapPin, ChevronRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function RoutePagesSection() {
  const [routePages, setRoutePages] = useState([]);

  useEffect(() => {
    const fetchRoutePages = async () => {
      try {
        const response = await axios.get(`${API}/cms/pages`);
        const published = (response.data.pages || []).filter(p => p.status === "published");
        setRoutePages(published);
      } catch (error) {
        console.error("Failed to fetch route pages:", error);
      }
    };
    fetchRoutePages();
  }, []);

  if (routePages.length === 0) return null;

  return (
    <section className="py-16 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Service Areas</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">We provide premium taxi and airport transfer services across these locations</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3">
          {routePages.map((page) => {
            const locationName = page.title
              .replace("Airport Taxi Transfer Service in ", "")
              .replace("Airport Taxi Transfer Services in ", "")
              .replace("Taxi Service in ", "")
              .replace("Taxi Services in ", "");
            return (
              <Link
                key={page.id}
                to={`/${page.slug}`}
                className="bg-white p-3 rounded-lg shadow-sm hover:shadow-md transition-all hover:bg-orange-50 group flex items-center gap-2"
              >
                <MapPin size={14} className="text-orange-500 flex-shrink-0" />
                <span className="text-sm text-gray-700 group-hover:text-orange-600 truncate">{locationName}</span>
                <ChevronRight size={14} className="text-gray-400 group-hover:text-orange-500 flex-shrink-0 ml-auto" />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
